import { type FC } from 'react'
import { type useRefinementList } from 'react-instantsearch'

import { Checkbox, Option, type OptionProps } from 'base-ui'

import styles from './ProductSearchRefinementCheckboxOption.module.css'

type Item = ReturnType<typeof useRefinementList>['items'][number]

type ProductSearchRefinementCheckboxOptionProps = Omit<
  OptionProps<Item>,
  'className' | 'label' | 'value'
> & {
  item: Item & {
    labelPrefix?: string
  }
}

export const ProductSearchRefinementCheckboxOption: FC<
  ProductSearchRefinementCheckboxOptionProps
> = ({ item, ...restProps }) => {
  return (
    <Option
      {...restProps}
      className={styles['product-search-checkbox-refinement-option']}
      label={item.label}
      value={item}
    >
      <Checkbox
        checked={item.isRefined}
        className="pointer-events-none shrink-0"
        data-qa-id={`form-refinement-control-${restProps['data-attribute']}-${item.label}`}
        readOnly
      />
      <span>
        {item.labelPrefix ? (
          <span className="text-m font-medium italic text-dark-brand">
            {item.labelPrefix}{' '}
          </span>
        ) : null}
        {`${item.label} (${item.count})`}
      </span>
    </Option>
  )
}
